###
@TODO: This class is intended to replace BaseController
###
class AbstractController extends AbstractClass
	@inject '$scope',
		'$stateParams'
		'translate'
		'MessageTerminal'
		'ToastService'
		'Guid'

	@register: (module = null) ->
		@registerController module

	$onInit: ->
		@controllerId = 'ctrl-' + @constructor.name.toLowerCase() + '-' + @Guid.randomString(4)

		@resetErrors()

		# Make alias for mainCrud in controller
		if angular.isDefined(@$scope.mainCrud)
			@mainCrud = @$scope.mainCrud
			@mainCrud.reset()
			@mainCrud.isNewEntity = _.isEmpty(@$stateParams.id)

		@initialize?()

	removeErrorMessage: (key) ->
		@errorMessages = _.omit @errorMessages, key

	addErrorMessage: (key, value) ->
		if angular.isObject value
			for key, response of value
				@handleErrors(response, null)

			return

		@errorMessages[key] = value

	handleErrors: (response, title = null) ->
		@resetErrors()

		if !response?
			return

		if title && response.is_handled != true
			@ToastService.showErrors response, @translate(title)

		if response.data? && !response.errors?
			response = response.data

		console.error response

		if angular.isDefined response.errors
			angular.forEach response.errors, (error, key) =>
				@addErrorMessage key, if angular.isArray error then error[0] else error

	resetErrors: ->
		@errorMessages = {}

	hasErrorMessages: ->
		return !_.isEmpty @errorMessages
